export default "__VITE_ASSET__56aef650__"